//TODO mover esse utils para shared?
import { fetchStateNameByAbbreviation } from '~/packages/insight/insight.constants'
import { User } from '~/prix'

export const SUGGESTED_QUESTIONS: string[] = [
  'O que tem para mim hoje?',
  'Quais são as UFs com baixa utilização do portfólio de Gestão Empresarial?',
  'Quais são os produtos com baixo NPS?',
  'Quais são os 10 produtos com melhores IDS no portfólio de Inovação?',
]

export function getSuggestedQuestionsForUser(user: User | null): string[] {
  if (
    user?.roles.some(item => ['stateManager', 'appSebraeStateManager'].includes(item)) &&
    user.stateAbbreviation
  ) {
    const state = fetchStateNameByAbbreviation(user.stateAbbreviation)
    return [
      'O que tem para mim hoje?',
      `Quais são os produtos com baixa utilização em ${state}?`,
      `Quais são os produtos com baixo NPS em ${state}?`,
      `Quais são os 10 melhores produtos em ${state}?`,
    ]
  }
  return SUGGESTED_QUESTIONS
}
